import { render } from "./EnPageTitle.vue?vue&type=template&id=cd1057ae"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/layout/EnPageTitle/EnPageTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cd1057ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cd1057ae', __exports__)) {
    api.reload('cd1057ae', __exports__)
  }
  
  module.hot.accept("./EnPageTitle.vue?vue&type=template&id=cd1057ae", () => {
    api.rerender('cd1057ae', render)
  })

}


export default __exports__